import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71c52b36"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "title header-title mt-3" }, "ルーティン配信設定")
], -1))
const _hoisted_2 = { class: "input-group flex flex-column gap-2 mt-5" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "menu-title" }, [
  /*#__PURE__*/_createTextVNode("配信頻度設定 "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-text" }, " 必須 ")
], -1))
const _hoisted_4 = {
  key: 0,
  class: "p-error text-sm mt-3 d-block"
}
const _hoisted_5 = { class: "field col-12 px-0 ml-2 mt-3" }
const _hoisted_6 = { class: "flex flex-wrap gap-3" }
const _hoisted_7 = { class: "col-2 flex align-items-center radio-wrapper__custom" }
const _hoisted_8 = {
  key: 0,
  class: "icon-lms icon-lms_rad-chosen radio-icon"
}
const _hoisted_9 = {
  key: 1,
  class: "icon-lms icon-lms_radio radio-icon"
}
const _hoisted_10 = { class: "col-2 flex align-items-center radio-wrapper__custom" }
const _hoisted_11 = {
  key: 0,
  class: "icon-lms icon-lms_rad-chosen radio-icon"
}
const _hoisted_12 = {
  key: 1,
  class: "icon-lms icon-lms_radio radio-icon"
}
const _hoisted_13 = { class: "col-2 flex align-items-center radio-wrapper__custom" }
const _hoisted_14 = {
  key: 0,
  class: "icon-lms icon-lms_rad-chosen radio-icon"
}
const _hoisted_15 = {
  key: 1,
  class: "icon-lms icon-lms_radio radio-icon"
}
const _hoisted_16 = { class: "col-2 flex align-items-center radio-wrapper__custom" }
const _hoisted_17 = {
  key: 0,
  class: "icon-lms icon-lms_rad-chosen radio-icon"
}
const _hoisted_18 = {
  key: 1,
  class: "icon-lms icon-lms_radio radio-icon"
}
const _hoisted_19 = {
  key: 0,
  class: "grid mt-5 justify-content-center"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/images/warning-logo.png",
    alt: "Warning Logo",
    class: "warning-logo mr-4 ml-2"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "mb-2" }, "保存されていない設定情報は破棄されます。破棄しますか？")
], -1))
const _hoisted_21 = {
  key: 0,
  class: "grid mt-5 mb-5 justify-content-center"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/images/warning-logo.png",
    alt: "Warning Logo",
    class: "warning-logo mr-4 ml-2"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "mb-2" }, "保存されていない設定情報は破棄されます。破棄しますか？")
], -1))
const _hoisted_23 = { class: "grid mt-5 mb-5 justify-content-center" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center w-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "mb-2 p-dialog-title" }, "下書き保存しました")
], -1))
const _hoisted_25 = { class: "grid mt-5 mb-5 justify-content-center" }

import { ref, onBeforeMount, onBeforeUnmount, onMounted } from "vue";
// Vue関連のインポート
import { get, set } from "@vueuse/core";
import { onBeforeRouteLeave, useRouter } from "vue-router";

// PrimeVueコンポーネントのインポート
import RadioButton from "primevue/radiobutton";
import Toast from "primevue/toast";

// サードパーティライブラリのインポート
import { useStore } from "vuex";
import { useToast } from "primevue/usetoast";

// サービス・ユーティリティのインポート
import DistributionGroupService from "@/clinic/services/distribution_group_service";
import RouterConstants from "@/clinic/constants/router.constants";
import RouterUtils from "@/common/utils/router.util";
import { notityErrorMsg } from "@/clinic/utils/notify-utils";
import ApiRouterConstants from "@/clinic/constants/api.router.constants";

/**
 * コンポーネントのプロパティ定義
 * @type {Object}
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'DeliverySetting',
  props: {
    isEdit: { type: Boolean },
    finalSetting: { type: Boolean },
    distributionGroupId: null,
    deliverySetting: null
  },
  emits: ["resourcesFn", "saveDeliverySetting", "changeTargetViewType"],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  /** 編集モードかどうか */
  isEdit: boolean;
  /** 最終設定モードかどうか */
  finalSetting: boolean;
  /** 配信グループID */
  distributionGroupId: string | number;
  /** 配信設定情報 */
  deliverySetting: {
    delivery_type: string;
    delivery_frequency?: number;
  };
};

/**
 * ルーティン配信設定コンポーネント
 *
 * このコンポーネントはルーティン配信グループの配信設定を管理し、
 * 以下の機能を提供します：
 * - 配信頻度設定（2回〜5回配信）
 * - 下書き保存機能
 * - ページ離脱時の警告
 *
 * @component DeliverySetting
 * @description ルーティン配信グループの配信設定を管理するコンポーネント
 */

// Vue関連のインポート


/**
 * Vuexストア
 * @type {Store}
 */
const store = useStore();

/**
 * クリニックID
 * @type {Ref<string>}
 */
const clinicId = ref("");

/**
 * トースト通知
 * @type {UseToast}
 */
const toast = useToast();

/**
 * ルーター
 * @type {Router}
 */
const router = useRouter();

/**
 * 次のルート
 * @type {Ref<string | null>}
 */
const nextRoute = ref<string | null>(null);

/**
 * 既に下書き保存済みかどうか
 * @type {Ref<boolean>}
 */
const isAlreadySaveDraft = ref(false);

/**
 * ページ離脱許可フラグ
 * @type {Ref<boolean>}
 */
const hasPermissionRedirect = ref(false);

/**
 * ページ離脱警告表示フラグ
 * @type {Ref<boolean>}
 */
const warningRedirectPage = ref(false);

/**
 * イベントエミッター
 */


/**
 * 配信タイプ
 * @type {Ref<number>}
 */
const deliveryType = ref(props.deliverySetting?.delivery_frequency);

/**
 * 戻る警告ダイアログ表示フラグ
 * @type {Ref<boolean>}
 */
const warningReturnVisible = ref(false);

/**
 * 下書き保存完了ダイアログ表示フラグ
 * @type {Ref<boolean>}
 */
const saveDraftVisible = ref(false);

/**
 * 配信設定エラー
 * @type {Ref<Record<string, any>>}
 */
const deliverySettingErrors = ref<Record<string, any>>({});

/**
 * 戻るボタンの処理
 */
const handleBackButton = () => {
  if (isAlreadySaveDraft.value) {
    previousStep();
  } else {
    warningReturnVisible.value = true;
  }
};

/**
 * 前のステップに戻る処理
 */
const previousStep = () => {
  warningReturnVisible.value = false;
  emits("changeTargetViewType", "setting");
  emits("resourcesFn", 2);
};

/**
 * TOPページに戻る処理
 */
const returnTop = () => {
  set(hasPermissionRedirect, true);
  warningReturnVisible.value = false;
  RouterUtils.goTo(RouterConstants.DISTRIBUTION_ROUTINE_GROUP_ROUTER_NAME);
};

/**
 * 現在のページに戻る処理
 */
const returnCurrentPage = () => {
  warningReturnVisible.value = false;
  saveDraftVisible.value = false;
};

/**
 * パラメータの構築
 * @returns {Object} 配信設定パラメータ
 */
const handleParams = () => {
  return {
    delivery_frequency: deliveryType.value,
  };
};

/**
 * 下書き保存用パラメータの構築
 * @returns {Object} 下書き保存パラメータ
 */
const saveDraftParams = () => ({
  ...handleParams(),
  status: 5,
});

/**
 * 次のステップに進む処理
 */
const next = async () => {
  try {
    const body = handleParams();
    const params = { clinic_id: clinicId.value };
    const response = await DistributionGroupService.updateDeliverySettings(props.distributionGroupId, params, body);
    emits("saveDeliverySetting", 4, response.data.value);
  } catch (error: any) {
    notityErrorMsg(toast, "何かが間違っています。後でもう一度試してください");
    document.getElementById("step-setting")?.scrollIntoView();
    console.log("errors", error);
    deliverySettingErrors.value = error.response?.data?.errors || {};
  }
};

/**
 * 下書き保存の処理
 * @returns {Promise<any>} 保存結果
 */
const handleSaveDraft = async () => {
  const body = saveDraftParams();
  const params = { clinic_id: clinicId.value };
  return await DistributionGroupService.updateDeliverySettings(props.distributionGroupId, params, body);
};

/**
 * 下書き保存処理
 */
const saveDraft = async () => {
  try {
    set(deliverySettingErrors, {});
    const response = await handleSaveDraft();
    if (!response) return;

    set(isAlreadySaveDraft, true);
    emits("saveDeliverySetting", 3, response.data.value);
    if (get(warningReturnVisible)) {
      previousStep();
    } else {
      set(warningReturnVisible, false);
      set(saveDraftVisible, true);
    }
  } catch (error: any) {
    notityErrorMsg(toast, "何かが間違っています。後でもう一度試してください");
    document.getElementById("step-setting")?.scrollIntoView();
    warningReturnVisible.value = false;
    deliverySettingErrors.value = error.response?.data?.errors || {};
  }
};

/**
 * クリニック情報の読み込み
 */
const loadClinicInfo = async () => {
  const storeClinicId = await store.dispatch("authClient/getClinicIdCookie");
  clinicId.value = storeClinicId;
};

/**
 * ページ離脱前の処理
 * @param {BeforeUnloadEvent} event - ページ離脱イベント
 */
const handleBeforeUnload = (event: BeforeUnloadEvent) => {
  event.preventDefault();
  event.returnValue = "";
  window.addEventListener("unload", async function () {
    if (!props.isEdit) {
      const url = `${ApiRouterConstants.API_DISTRIBUTION_GROUPS}/${props.distributionGroupId}`;
      await fetch(url, { method: "DELETE", keepalive: true });
    }
  });
};

/**
 * リダイレクト時の下書き保存処理
 */
const saveDraftWhenRedirect = async () => {
  try {
    await handleSaveDraft();
    saveDraftVisible.value = false;
    set(hasPermissionRedirect, true);
    if (nextRoute.value) {
      router.push(nextRoute.value);
    }
  } catch (error: any) {
    warningRedirectPage.value = false;
    deliverySettingErrors.value = error.response?.data?.errors || {};
    notityErrorMsg(toast, "何かが間違っています。後でもう一度試してください");
  }
};

onBeforeRouteLeave((to, _from, next) => {
  if (props.finalSetting) {
    next();
    return;
  }

  if (get(hasPermissionRedirect)) {
    next();
  } else {
    set(warningRedirectPage, true);
    set(nextRoute, to.fullPath);
    next(false);
  }
});

/**
 * リダイレクト時の破棄処理
 */
const destroyWhenRedirect = async () => {
  try {
    if (!props.isEdit) {
      await DistributionGroupService.destroy(props.distributionGroupId);
    }
    set(hasPermissionRedirect, true);
    if (nextRoute.value) {
      router.push(nextRoute.value);
    }
  } catch (error) {
    console.log("error", error);
  }
};

onBeforeUnmount(() => {
  window.removeEventListener("beforeunload", handleBeforeUnload);
});

/**
 * コンポーネントマウント時の処理
 */
onMounted(() => {
  window.addEventListener("beforeunload", handleBeforeUnload);
  document.getElementById("step-setting")?.scrollIntoView();
});

/**
 * コンポーネントマウント前の処理
 */
onBeforeMount(async () => {
  set(hasPermissionRedirect, false);
  await loadClinicInfo();
});

return (_ctx: any,_cache: any) => {
  const _component_Card = _resolveComponent("Card")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["main-content-wrapper", { 'pointer-events-none': props.finalSetting }])
    }, [
      _createVNode(_component_Card, { class: "mb-5 mt-3 border-round-lg" }, {
        header: _withCtx(() => [
          _hoisted_1
        ]),
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            (deliverySettingErrors.value?.delivery_frequency)
              ? (_openBlock(), _createElementBlock("small", _hoisted_4, _toDisplayString(deliverySettingErrors.value.delivery_frequency[0]), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_unref(RadioButton), {
                    modelValue: deliveryType.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((deliveryType).value = $event)),
                    inputId: "period-setting-2",
                    name: "display_price",
                    value: 2
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("label", {
                    for: "display-price",
                    class: _normalizeClass(["flex algin-items-center", { 'text-orange': deliveryType.value == 2 }]),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (deliveryType.value = 2))
                  }, [
                    (deliveryType.value == 2)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8))
                      : (_openBlock(), _createElementBlock("span", _hoisted_9)),
                    _createTextVNode(" 2回配信 ")
                  ], 2)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_unref(RadioButton), {
                    modelValue: deliveryType.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((deliveryType).value = $event)),
                    inputId: "period-setting-3",
                    name: "display_price",
                    value: 3
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("label", {
                    for: "period-setting-3",
                    class: _normalizeClass(["flex algin-items-center", { 'text-orange': deliveryType.value == 3 }]),
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (deliveryType.value = 3))
                  }, [
                    (deliveryType.value == 3)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11))
                      : (_openBlock(), _createElementBlock("span", _hoisted_12)),
                    _createTextVNode(" 3回配信 ")
                  ], 2)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_unref(RadioButton), {
                    modelValue: deliveryType.value,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((deliveryType).value = $event)),
                    inputId: "period-setting-4",
                    name: "display_price",
                    value: 4
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("label", {
                    for: "period-setting-4",
                    class: _normalizeClass(["flex algin-items-center", { 'text-orange': deliveryType.value == 4 }]),
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (deliveryType.value = 4))
                  }, [
                    (deliveryType.value == 4)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14))
                      : (_openBlock(), _createElementBlock("span", _hoisted_15)),
                    _createTextVNode(" 4回配信 ")
                  ], 2)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_unref(RadioButton), {
                    modelValue: deliveryType.value,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((deliveryType).value = $event)),
                    inputId: "period-setting-5",
                    name: "display_price",
                    value: 5
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("label", {
                    for: "period-setting-5",
                    class: _normalizeClass(["flex algin-items-center", { 'text-orange': deliveryType.value == 5 }]),
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (deliveryType.value = 5))
                  }, [
                    (deliveryType.value == 5)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_17))
                      : (_openBlock(), _createElementBlock("span", _hoisted_18)),
                    _createTextVNode(" 5回配信 ")
                  ], 2)
                ])
              ])
            ])
          ])
        ]),
        _: 1
      }),
      (props.finalSetting == false)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createVNode(_component_Button, {
              class: "col-2 black-btn ml-5",
              label: "前設定へ戻る",
              onClick: handleBackButton
            }),
            _createVNode(_component_Button, {
              class: "col-2 temp-save-btn ml-5",
              label: "下書き保存",
              onClick: saveDraft
            }),
            _createVNode(_component_Button, {
              class: "col-2 create-btn ml-5",
              label: "メッセージ設定へ進む",
              onClick: next
            })
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(_component_Dialog, {
      visible: warningReturnVisible.value,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((warningReturnVisible).value = $event)),
      modal: "",
      style: { width: '720px' },
      class: "mx-5 dialog-note border-0",
      draggable: false
    }, {
      header: _withCtx(() => [
        _hoisted_20
      ]),
      default: _withCtx(() => [
        (props.finalSetting == false)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createVNode(_component_Button, {
                class: "col-3 temp-save-btn mr-5",
                label: "下書き保存",
                onClick: saveDraft
              }),
              _createVNode(_component_Button, {
                class: "col-3 black-btn mr-5",
                label: "戻る",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (warningReturnVisible.value = false))
              }),
              _createVNode(_component_Button, {
                class: "col-3 confirm-delete-btn",
                label: "破棄する",
                onClick: previousStep
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: warningRedirectPage.value,
      "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => ((warningRedirectPage).value = $event)),
      modal: "",
      style: { width: '720px' },
      class: "mx-5 dialog-note border-0 text-center",
      draggable: false
    }, {
      header: _withCtx(() => [
        _hoisted_22
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_23, [
          _createVNode(_component_Button, {
            class: "col-3 temp-save-btn mr-5",
            label: "下書き保存",
            onClick: saveDraftWhenRedirect
          }),
          _createVNode(_component_Button, {
            class: "col-3 black-btn mr-5",
            label: "戻る",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (warningRedirectPage.value = false))
          }),
          _createVNode(_component_Button, {
            class: "col-3 confirm-delete-btn",
            label: "破棄する",
            onClick: destroyWhenRedirect
          })
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: saveDraftVisible.value,
      "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((saveDraftVisible).value = $event)),
      modal: "",
      style: { width: '550px' },
      class: "mx-5 dialog-note border-0 text-center",
      draggable: false
    }, {
      header: _withCtx(() => [
        _hoisted_24
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_25, [
          _createVNode(_component_Button, {
            class: "col-3 black-btn ml-5",
            label: "TOPに戻る",
            onClick: returnTop
          }),
          _createVNode(_component_Button, {
            class: "col-3 create-btn ml-5",
            label: "作成を続ける",
            onClick: returnCurrentPage
          })
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_unref(Toast), { position: "top-center" })
  ], 64))
}
}

})